<template>
  <div>
    <div class="columns">
      <div class="column is-one-fifth">
        <b-button v-if="!readonly" class="button is-primary" type="button" @click="showDialog()">
          添付
        </b-button>
      </div>

      <div class="column">
        <div v-for="(fileInfo, index) in fileInfos" :key="index">
          <div v-if="!fileInfo.isDeleted">
            <b-checkbox v-if="!readonly" v-model="selectedFiles[index]" name="isSelected"/>
            <g-link v-model="fileInfo.fileName" @click="downloadFile(fileInfo)"></g-link>
          </div>
        </div>
      </div>

      <div class="column is-one-fifth">
        <b-button
          v-if="!readonly"
          class="button is-primary"
          type="button"
          @click="deleteFiles()"
          style="float: right; white-space: nowrap"
        >
          削除
        </b-button>
      </div>
    </div>

    <!-- ファイル選択画面 -->
    <b-modal :active.sync="isShowDialog" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: 100%">
          <header class="modal-card-head">
            <p
              class="modal-card-title"
              style="color: whitesmoke; text-align: left"
            >
              ファイル選択
            </p>
          </header>
          <section class="modal-card-body">
            <b-field class="file">
              <b-upload
                multiple
                expanded
                @input="selectFiles($event)"
                style="display: block; floot: left; width: 100%"
              >
                <a class="button is-primary is-fullwidth">
                  <b-icon icon="upload"></b-icon>
                  <span>添付するファイルを選択してください</span>
                </a>
              </b-upload>
            </b-field>

            <b-field style="width: 100%">
              <b-upload
                multiple
                drag-drop
                expanded
                @input="selectFiles($event)"
                style="display: block; floot: left; width: 100%"
              >
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"></b-icon>
                    </p>
                    <p>添付するファイルをドロップしてください</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
          </section>

          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeDialog()">
              閉じる
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "FileChooser",
  props: {
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    downloadFile: function (fileInfo) {
      if (!fileInfo.file) {
        this.$emit("download-file", fileInfo);
      } else {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(fileInfo.file);
        link.download = decodeURI(fileInfo.file.name);
        link.click();
      }
    },

    showDialog: function () {
      this.isShowDialog = true;
      return;
    },

    closeDialog: function () {
      this.isShowDialog = false;
      return;
    },

    selectFiles: function (files) {
      for (const file of files) {
        let fileInfo = this.fileInfos.find((elem) => elem.fileName == file.name);
        if (!fileInfo) {
          fileInfo = {};
          this.fileInfos.push(fileInfo);
        }

        fileInfo.file = file;
        fileInfo.fileName = file.name;
        fileInfo.isDeleted = false;
      }

      this.selectedFiles = new Array(this.fileInfos.length).fill(false);

      this.$emit("input", this.fileInfos);
      this.isShowDialog = false;
      return;
    },

    deleteFiles: function () {
      for (let i = 0; i < this.selectedFiles.length; ++i) {
        if (this.selectedFiles[i]) {
          this.$set(this.fileInfos[i], "isDeleted", true);
        }
      }
      // s3未送信のファイルは送らない
      this.fileInfos = this.fileInfos.filter((elem) => {
        if (!elem.id && elem.isDeleted) {
          return false;
        } else {
          return true;
        }
      });

      this.selectedFiles = new Array(this.fileInfos.length).fill(false);
      this.$emit("input", this.fileInfos);
      return;
    },
  },

  data() {
    return {
      fileInfos: structuredClone(this.value),
      selectedFiles: new Array(this.value.length).fill(false),
      isShowDialog: false,
    };
  },

  watch: {
    value: {
      handler: function () {
        this.fileInfos = structuredClone(this.value);
      },
      deep: true,
    },
  },

  filters: {},

  components: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/FileChooser.vue